<template>
    <div>
        {{ texto }} <i class="fa fa-spinner fa-spin fa-sm" aria-hidden="true"></i>
    </div>
</template>

<script>
export default {
    props: {
        texto:String
    }
}
</script>